import * as React from "react";
const SvgMeasure = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "measure_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "measure_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "m19 2-14.69.1a2.08 2.08 0 0 0-2.08 2.1v7.73a2.11 2.11 0 0 0 2.11 2.09l15.31-.11a2.08 2.08 0 0 0 2.08-2.1V4.08A2.11 2.11 0 0 0 19.62 2zm.57 2.16v7.59h-1.05V7.42a1.08 1.08 0 0 0-1.09-1.08 1.08 1.08 0 0 0-1.07 1.09v4.37h-1.45v-1.08a1.08 1.08 0 0 0-1.09-1.07 1.08 1.08 0 0 0-1.08 1.09v1.08H11.3V7.49a1.08 1.08 0 0 0-1.09-1.08 1.09 1.09 0 0 0-1.1 1.1v4.34H7.68v-1.08A1.08 1.08 0 0 0 6.59 9.7a1.08 1.08 0 0 0-1.08 1.09v1.08H4.43V4.28ZM21.74 17.65l-2.47-1.85a1 1 0 0 0-1.4.2 1 1 0 0 0 .2 1.4l.8.6H5.28l.8-.6a1 1 0 0 0 .2-1.4 1 1 0 0 0-1.4-.2l-2.71 2a1.47 1.47 0 0 0 0 2.34l2.71 2a1 1 0 0 0 1.4-.2 1 1 0 0 0-.2-1.4l-.8-.6h13.59l-.8.6a1 1 0 0 0-.2 1.4 1 1 0 0 0 1.4.2l2.47-1.85a1.7 1.7 0 0 0 0-2.7Z",
	style: { fill: "currentColor" }
}))));
export default SvgMeasure;
